import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRingcentralRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#FF7A00",
		d: "M10 4h12q2.4-.2 4.3 1.5l.1.2h.1l1 1.7q.5 1.2.4 2.6v12a6 6 0 0 1-1.7 4.4v.1l-1.6 1q-1.4.5-2.7.4H10q-2.4.1-4.3-1.5l-.1-.2h-.1l-1-1.6Q3.9 23.2 4 22V10a6 6 0 0 1 1.7-4.4v-.1l1.7-1Q8.6 3.9 10 4M8 6.4a3 3 0 0 0-1.6 1.7 5 5 0 0 0-.2 2v11.5c0 1.2 0 1.2.3 2.4v.1A3 3 0 0 0 8 25.6q.9.4 1.9.3h11.7c1.2 0 1.2 0 2.4-.3h.1a3 3 0 0 0 1.6-1.7 5 5 0 0 0 .2-2V10.5c0-1.2 0-1.2-.3-2.4V8a3 3 0 0 0-1.7-1.6 5 5 0 0 0-2-.2H10.5C9.2 6 9.2 6 8 6.4"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#0684BC",
		d: "M12.3 9.4h8q1.3-.1 2.2.5.7.9.6 2v3.7q.2 1.4-.7 2.4-.7.6-1.5.9-.4 0-.7.3l.2.6.4.6.7 1 .6 1.1.1.3v.1h-2.6c-.6.1-.6.1-.8-.1l-.8-1-.8-1.4c-1-1.4-1-1.4-1-2.3v-1.3q0-.6.2-.6h2.9l.4-.2v-3.4h-6.8v9.8q0 .3-.2.5l-.4.1H9.8l-.3-.3V12.2Q9.4 11 10 10q1-.7 2.3-.6"
	})]
});
export default SvgRingcentralRegularIcon;
